import { render } from "./DayViewWorkAreaListGroup.vue?vue&type=template&id=a017fac0"
import script from "./DayViewWorkAreaListGroup.vue?vue&type=script&lang=ts"
export * from "./DayViewWorkAreaListGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script